import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  name: "",
  status: "",
  state_name: "",
};

export function CityFilter({ filterValues, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };

  const [cityFilter, setCityFilter] = useState(initialValues);

  return (
    <>
      <Formik
        initialValues={cityFilter}
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={(values) => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by status Type"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1">Active </option>
                  <option value="0">Deactive</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="City"
                  onBlur={handleBlur}
                  value={values.name}
                  onChange={(e) => {
                    setFieldValue("name", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>City</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="state_name"
                  placeholder="State"
                  onBlur={handleBlur}
                  value={values.state_name}
                  onChange={(e) => {
                    setFieldValue("state_name", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>State</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
